import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Popover from '@ui/popover/popover';
import RotatableIcon from '@ui/RotatableIcon/rotatable-icon';
import Text from '@ui/text/text/text';
import { WATERMARK_OPTIONS } from '../../../../constants/watermark.constants';

interface WatermarkTypeSelectorProps {
  value: (typeof WATERMARK_OPTIONS)[0];
  onChange: (option: (typeof WATERMARK_OPTIONS)[0]) => void;
}

const WatermarkTypeSelector = ({ value, onChange }: WatermarkTypeSelectorProps) => {
  return (
    <Container>
      <Text className="L2 margin-l-16 margin-b-2" design="GlobalIcoText3">
        Type
      </Text>
      <Popover
        backgroundColor="var(--gray-800)"
        closeOnClick
        width="100%"
        inheritRadius
        cycleWithArrowKeys
        contentClassName="margin-t-4"
        refocusTriggerOnClose
        renderTriggerButton={({ open, closing }) => (
          <Button
            border={`1px solid var(--global-ico-text-3)`}
            hoverBorder={`1px solid var(--global-ico-text-2)`}
            height="36px"
            width="100%"
            clear
            className="flex ai-center"
            borderRadius="100px"
            disabledOpacity={0.6}
          >
            <div className="flex flex-1 ai-center jc-space-between gap-6 padding-h-16">
              <div className="flex ai-center gap-10">
                <Icon name={value.icon} size={16} />
                <Text className="P2" design="GlobalIcoText1">
                  {value.label}
                </Text>
              </div>
              <RotatableIcon
                name={ICONS.KEYBOARD_ARROW_DOWN}
                size={12}
                color="var(--global-ico-text-1)"
                rotate={open && !closing ? '180deg' : '0'}
              />
            </div>
          </Button>
        )}
      >
        <Container background={'var(--gray-800)'} borderRadius="12px" width="100%">
          {WATERMARK_OPTIONS.map((option) => (
            <Button
              key={option.label}
              width="100%"
              className="radius-0 S2 text-left flex ai-center gap-10"
              hoverBackgroundColor="var(--gray-700)"
              onClick={() => onChange(option)}
            >
              <span className="flex flex-1 ai-center gap-10">
                <Icon name={option.icon} size={14} />
                {option.label}
              </span>
              {value.type === option.type && <Icon name={ICONS.CHECK} size={12} />}
            </Button>
          ))}
        </Container>
      </Popover>
    </Container>
  );
};

export default WatermarkTypeSelector;
